import React from "react";
import "./ContaAplicataSyllabus.css";

const modules = [
  {
    id: 1,
    title: "Monografia operatiunilor economice",
    description: "Aplicatii privind inregistrarea operatiunilor economice uzuale.",
    lessons: 12
  },
  {
    id: 2,
    title: "Stocuri si consumuri",
    description: "Aplicatii privind achizitia, consumul si evidenta stocurilor.",
    lessons: 10
  },
  {
    id: 3,
    title: "Marfuri si adaos comercial",
    description: "Aplicatii privind comertul cu amanuntul si descarcarea din gestiune.",
    lessons: 9
  }
];

function ContaAplicataSyllabus() {
  return (
    <div className="conta-primara-syllabus-page">
      <div className="conta-primara-syllabus-container">
        <div className="conta-primara-syllabus-header">
          <h1>Contabilitate aplicata</h1>
          <p>Aplica notiunile contabile in situatii practice si exercitii.</p>
        </div>

        <div className="conta-primara-modules-grid">
          {modules.map((module) => (
            <div key={module.id} className="conta-primara-module-card">
              <div className="conta-primara-module-content">
                <h2>{module.title}</h2>
                <p>{module.description}</p>
                <span>{module.lessons} lectii</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ContaAplicataSyllabus;